export default __webpack_public_path__ + "static/MrityunjayaP-03276f899df12dbbf39512e829aa9c29.png";